import { ConnectStores } from "lib/core/store"
import { LEARN } from "path/constants"
import PropTypes from "prop-types"
import PathItemControls from "../PathItemControls"
import "./PathStep.css"
import PathStepDetails from "./PathStepDetails"

const PathStep = function (props, { mode }) {
  const { item, isNext, isDragPreview, standalone, analytics, path } = props

  const completed = !!item.completion && item.completion.progress === 1

  const status =
    mode !== LEARN
      ? null
      : completed
      ? item.is_skipped
        ? "skipped"
        : "completed"
      : isNext
      ? "next"
      : "incomplete"

  let controls = []
  if (mode > LEARN) {
    controls = ["Stats", "Review", "Dates"]
  }
  if (mode >= LEARN && standalone) {
    controls.push("Notes")
  }
  if (standalone) {
    controls.unshift("Print")
  }

  return (
    <div className="PathStep">
      <PathStepDetails
        item={item}
        mode={mode}
        status={status}
        analytics={analytics}
        standalone={standalone}
        path={path}
      >
        {!!controls && !!controls.length && !isDragPreview && (
          <PathItemControls
            className="PathStep__controls"
            buttonStyles={{ styleType: "secondary" }}
            inlineControls={controls}
            item={item}
          />
        )}
      </PathStepDetails>
    </div>
  )
}

PathStep.displayName = "PathStep"
PathStep.contextTypes = { mode: PropTypes.number }

const mapStateToProps = function (state, ownProps) {
  const { path, next_step } = state.pathStore.state
  const { item, standalone } = ownProps

  const isNext = next_step === item.id
  const analytics = state.pathAnalyticsStore.request.getAnalyticsForItem(
    item.sync_source_id
  )

  return _.assign(
    {},
    {
      status,
      isNext,
      path,
      analytics
    },
    ownProps
  )
}

const stores = [
  { store: "path" },
  { store: "pathAnalytics", watch: ["item_analytics"] },
  { store: "resource" }
]

export default ConnectStores(PathStep, stores, {}, mapStateToProps)
